/**
 * Auth Feature
 *
 * Exports all auth-related functionality including:
 * - AuthProvider: Wraps the app to handle authentication
 * - useAuthStore: Zustand store for auth state
 * - useAuthGuard: Hook for protecting routes and handling auth errors
 * - authenticatedFetch: Fetch wrapper with auth headers and auto-refresh
 * - Types: Auth-related type definitions
 */

// Provider
export { AuthProvider } from "./auth-provider";

// Store
export { useAuthStore, reinitializeAuthAfterLegacyMigration } from "./auth-store";

// Hooks
export { useAuthGuard } from "./hooks/useAuthGuard";

// Services
export { authenticatedFetch, UnauthorizedError, ForbiddenError } from "./services/authenticated-fetch";

// Types
export type {
  User,
  Auth0TokenResponse,
  Auth0Response,
  Auth0Config,
  JWTClaims,
  JWT,
  AuthState,
  UseAuthGuardOptions,
  UseAuthGuardReturn,
} from "./types";
